<template>
  <div>
    <header class="entry-header">
      <h1
        class="entry-title"
        itemprop="headline"
      >POLÍTICA PROTECCIÓN DE DATOS PAGINA WEB</h1>
    </header>
    <div class="entry-content colorWeb" itemprop="text">
      <p>
        De acuerdo con la normativa de Protección de Datos de Carácter Personal, procedemos a informarle del tratamiento de datos personales que realizamos de nuestros clientes y/o usuarios de la presente página web.
      </p>
      <h2>1. Responsable de tratamiento de los datos</h2>
      <p>MARIA TERESA FREIRE PEREZ (en adelante VERSADA INMOBILIARIA)</p>
      <p>info@versadainmobiliaria.com</p>
      <h2>2. DPO</h2>
      <p>El delegado de Protección de Datos de MARIA TERESA FREIRE PEREZ es Servicios de Adaptación Continua en Protección de Datos RB, SL con el que podrá contactar en info@versadainmobiliaria.com.</p>
      <h2>3. Finalidad del tratamiento, legitimación y plazo de conservación</h2>
      <p>VERSADA INMOBILIARIA podrá tratar sus datos de carácter personal de acuerdo con las siguientes finalidades:</p>
      <p>SERVICIO DE ATENCIÓN AL USUARIO A TRAVÉS DEL FORMULARIO DE CONTACTO Y/O ENVÍO DE CORREOS ELECTRÓNICOS</p>
      <p>Finalidad de tratamiento: trataremos los datos estrictamente necesarios para gestionar su petición.</p>
      <p>Legitimación: existe un interés legítimo por ambas partes para la resolución de solicitudes o consultas.</p>
      <p>En caso de reclamaciones relacionadas con nuestros inmuebles, la legitimación es el cumplimiento de obligaciones legales por nuestra parte.</p>
      <p>Plazo de conservación: el tiempo necesario para dar respuesta a su solicitud y en cualquier caso, hasta que transcurra el plazo de prescripción de posibles acciones de responsabilidad derivadas del tratamiento.</p>
      <h2>4. Destinatarios de cesiones</h2>
      <p>VERSADA INMOBILIARIA no cederemos sus datos a terceros, salvo para dar cumplimiento a una obligación legal.</p>
      <h2>5. Política de cookies</h2>
      <p>Para revisar el tratamiento de datos relativo a las cookies, puede consultar la política de cookies, disponible en esta misma página web.</p>
      <p>Podrá configurar sus preferencias respecto al uso de cookies en el propio aviso de configuración de cookies.</p>
      <h2>6. Derechos</h2>
      <p>Por último, le informamos de sus derechos en materia de protección de datos.</p>
      <ul>
        <li>Derecho a solicitar el acceso a sus datos personales.</li>
        <li>Derecho a solicitar su rectificación o supresión.</li>
        <li>Derecho a solicitar la limitación de su tratamiento, y a oponerse al tratamiento.</li>
        <li>Derecho a la portabilidad de los datos.</li>
        <li>Derecho a la retirada de su consentimiento.</li>
      </ul>
      <p>Puede enviar su solicitud a través de la cuenta de correo electrónico: info@versadainmobiliaria.com.</p>
      <p>Si considera que no hemos atendido correctamente sus derechos, podrá formular una reclamación ante la Agencia Española de Protección de Datos, a través de las siguientes vías:</p>
      <ul>
        <li>Sede electrónica: <a href='https://www.aepd.es/'>www.aepd.es</a></li>
        <li>Correo postal: C/ Jorge Juan 6, 28001 – Madrid</li>
        <li>Teléfono: 901 100 099 – 91 266 35 17</li>
      </ul>
      <h2>7. Medidas de seguridad</h2>
      <p>VERSADA INMOBILIARIA tiene implantadas las medidas técnicas y organizativas necesarias para garantizar la seguridad de sus datos de carácter personal y evitar su alteración, la pérdida y el tratamiento y/o el acceso no autorizado, teniendo en cuenta el estado de la tecnología, la naturaleza de los datos almacenados y los riesgos provenientes de la acción humana o del medio físico y natural a que están expuestas.</p>    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>